import React, { Fragment } from 'react';
import Dashboard from './Pages/Dashboard';
import AppHeader from '../../Layout/AppHeader';
import AppSidebar from '../../Layout/AppSidebar';
import AppFooter from '../../Layout/AppFooter';

const DashboardWrapper = ({ match }) => (
    <Fragment>
        <AppHeader />
        <div className="app-main">
            <AppSidebar />
            <div className="app-main__outer">
                <div className="app-main__inner">
                    <Dashboard />
                </div>
                <AppFooter />
            </div>
        </div>
    </Fragment>
);

export default DashboardWrapper;